require('../../modules/es6.object.define-properties');
var $Object = require('../../modules/_core').Object;
module.exports = function defineProperties(T, D) {
  return $Object.defineProperties(T, D);
};



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/library/fn/object/define-properties.js